export default{
    'BASE_URL': 'https://rtwz-andromeda-orbital.herokuapp.com',
    'REFRESH_TOKEN_INTERVAL': 15*60*1000
}